import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.set";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import { lighten, makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { TextField, FormControl, FormControlLabel, Switch, InputLabel, Select, MenuItem, Checkbox, ListItemText, Button, Divider, Collapse, Box, Typography, Table, TableBody, TableCell, TableRow, TableSortLabel, TablePagination, TableHead, IconButton, Tooltip, Dialog, DialogTitle, DialogActions, makeStyles as makeStyles$1 } from '@material-ui/core';
import TuneIcon from '@material-ui/icons/Tune';
import FilterListIcon from '@material-ui/icons/FilterList';
import ColumnsIcon from '@material-ui/icons/ViewColumn';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import TableCell$1 from '@material-ui/core/TableCell';
import TableHead$1 from '@material-ui/core/TableHead';
import TableRow$1 from '@material-ui/core/TableRow';
import TableSortLabel$1 from '@material-ui/core/TableSortLabel';
import Checkbox$1 from '@material-ui/core/Checkbox';
import Button$1 from '@material-ui/core/Button';
import Dialog$1 from '@material-ui/core/Dialog';
import DialogActions$1 from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle$1 from '@material-ui/core/DialogTitle';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton$1 from '@material-ui/core/IconButton';
import Tooltip$1 from '@material-ui/core/Tooltip';
import Typography$1 from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
import InputLabel$1 from '@material-ui/core/InputLabel';
import MenuItem$1 from '@material-ui/core/MenuItem';
import FormControl$1 from '@material-ui/core/FormControl';
import ListItemText$1 from '@material-ui/core/ListItemText';
import Select$1 from '@material-ui/core/Select';
import Collapse$1 from '@material-ui/core/Collapse';
import Toolbar from '@material-ui/core/Toolbar';
import Table$1 from '@material-ui/core/Table';
import TableBody$1 from '@material-ui/core/TableBody';
import TablePagination$1 from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};
/**
 * Utility function used for a descending sort
 * @param {*} a
 * @param {*} b
 * @param {*} orderBy
 */


var desc = function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
};
/**
 * Utility function used to sort data
 * @param {*} array
 * @param {*} cmp
 */


var stableSort = function stableSort(array, cmp) {
  var stabilizedThis = array.map(function (el, index) {
    return [el, index];
  });
  stabilizedThis.sort(function (a, b) {
    var order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(function (el) {
    return el[0];
  });
};
/**
 * Utility function used to return the current sort
 * @param {*} order
 * @param {*} orderBy
 */


var getSorting = function getSorting(order, orderBy) {
  return order === "desc" ? function (a, b) {
    return desc(a, b, orderBy);
  } : function (a, b) {
    return -desc(a, b, orderBy);
  };
};
/**
 * Utility function used to set the appropriate color
 * for a Material UI form input
 * @param {Enumerator} color enum "primary", "secondary", "info", "error"
 * @param {object} theme Material UI theme
 * @param {number} lightenFactor factor to lighten color by
 */


var setInputColor = function setInputColor(color, theme, lightenFactor) {
  var validColorOptions = ["primary", "secondary", "info", "error"];

  if (validColorOptions.includes(color)) {
    if (lightenFactor) {
      return lighten(theme.palette[color].main, lightenFactor);
    }

    return theme.palette[color].main;
  }

  return null;
};
/**
 * Utility function used to assign the proper
 * class based on the variant
 * @param {string} variant i.e. standard, outlined, filled
 */


var setClass = function setClass(classes, variant) {
  var classSuffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "TextField";

  if (variant === "outlined") {
    return classes["outlined" + classSuffix];
  } else if (variant === "filled") {
    return classes["filled" + classSuffix];
  } else {
    return classes[classSuffix];
  }
};
/**
 * Utility function used to return the appropriate width
 * for a form element
 * @param {number} width
 * @param {boolean} fullWidth
 */


var setWidth = function setWidth(width, fullWidth) {
  if (fullWidth) {
    return "100%";
  } else if (width) {
    return width;
  }
};

var useStyles = makeStyles(function (theme) {
  return {
    TextField: {
      margin: theme.spacing(1),
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    outlinedTextField: {
      margin: theme.spacing(1),
      "& input + fieldset": {
        borderColor: function borderColor(props) {
          return setInputColor(props.outlineColor, theme);
        },
        borderWidth: 1.5
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    filledTextField: {
      margin: theme.spacing(1),
      "& div": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.85);
        }
      },
      "& div:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& div:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& input:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& input:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    }
  };
});

var DatePicker = function DatePicker(_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$variant = _ref.variant,
      variant = _ref$variant === undefined ? "standard" : _ref$variant,
      _ref$outlineColor = _ref.outlineColor,
      outlineColor = _ref$outlineColor === undefined ? "default" : _ref$outlineColor,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === undefined ? "default" : _ref$fillColor,
      _ref$labelColor = _ref.labelColor,
      labelColor = _ref$labelColor === undefined ? "default" : _ref$labelColor,
      width = _ref.width,
      other = objectWithoutProperties(_ref, ["name", "label", "value", "onChange", "variant", "outlineColor", "fillColor", "labelColor", "width"]);
  var classes = useStyles({
    outlineColor: outlineColor,
    fillColor: fillColor,
    labelColor: labelColor
  });
  return React.createElement(TextField, _extends({
    "data-testid": "date-filter",
    type: "date",
    variant: variant,
    id: name,
    name: name,
    label: label,
    value: value,
    onChange: onChange,
    className: setClass(classes, variant),
    style: {
      width: setWidth(width, other.fullWidth)
    }
  }, other));
};

DatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.string,
  width: PropTypes.number,
  outlineColor: PropTypes.string,
  fillColor: PropTypes.string,
  labelColor: PropTypes.string
};
var useStyles$1 = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1)
    }
  };
});

var Switch$1 = function Switch$$1(props) {
  var name = props.name,
      label = props.label,
      checked = props.checked,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === undefined ? "outlined" : _props$variant,
      onChange = props.onChange,
      other = objectWithoutProperties(props, ["name", "label", "checked", "value", "variant", "onChange"]);
  var classes = useStyles$1();
  return React.createElement(FormControl, {
    className: classes.formControl,
    variant: variant
  }, React.createElement(FormControlLabel, {
    control: React.createElement(Switch, _extends({
      "data-testid": "switch",
      name: name,
      checked: checked,
      onChange: onChange,
      value: value
    }, other)),
    label: label
  }));
};

Switch$1.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
var useStyles$2 = makeStyles(function (theme) {
  return {
    TextField: {
      margin: theme.spacing(1),
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    outlinedTextField: {
      margin: theme.spacing(1),
      "& input + fieldset": {
        borderColor: function borderColor(props) {
          return setInputColor(props.outlineColor, theme);
        },
        borderWidth: 1.5
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    filledTextField: {
      margin: theme.spacing(1),
      "& div": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.85);
        }
      },
      "& div:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& div:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& input:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& input:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    }
  };
});

var TextField$1 = function TextField$$1(props) {
  var name = props.name,
      label = props.label,
      value = props.value,
      variant = props.variant,
      onChange = props.onChange,
      width = props.width,
      outlineColor = props.outlineColor,
      fillColor = props.fillColor,
      labelColor = props.labelColor,
      other = objectWithoutProperties(props, ["name", "label", "value", "variant", "onChange", "width", "outlineColor", "fillColor", "labelColor"]);
  var classes = useStyles$2({
    outlineColor: outlineColor,
    fillColor: fillColor,
    labelColor: labelColor
  });
  return React.createElement(TextField, _extends({
    "data-testid": "text-field",
    id: name,
    name: name,
    variant: variant,
    label: label,
    value: value,
    onChange: onChange,
    className: setClass(classes, variant),
    style: {
      width: setWidth(width, other.fullWidth)
    }
  }, other));
};

TextField$1.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  variant: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.number,
  outlineColor: PropTypes.string,
  fillColor: PropTypes.string,
  labelColor: PropTypes.string
};
var useStyles$3 = makeStyles(function (theme) {
  return {
    TextField: {
      margin: theme.spacing(1),
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    outlinedTextField: {
      margin: theme.spacing(1),
      "& textarea + fieldset": {
        borderColor: function borderColor(props) {
          return setInputColor(props.outlineColor, theme);
        },
        borderWidth: 1.5
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    filledTextField: {
      margin: theme.spacing(1),
      "& div": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.85);
        }
      },
      "& div:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& div:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& input:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& input:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    }
  };
});

var TextArea = function TextArea(props) {
  var name = props.name,
      label = props.label,
      value = props.value,
      variant = props.variant,
      _props$rows = props.rows,
      rows = _props$rows === undefined ? 4 : _props$rows,
      onChange = props.onChange,
      width = props.width,
      outlineColor = props.outlineColor,
      fillColor = props.fillColor,
      labelColor = props.labelColor,
      other = objectWithoutProperties(props, ["name", "label", "value", "variant", "rows", "onChange", "width", "outlineColor", "fillColor", "labelColor"]);
  var classes = useStyles$3({
    outlineColor: outlineColor,
    fillColor: fillColor,
    labelColor: labelColor
  });
  return React.createElement(TextField, _extends({
    "data-testid": "text-area",
    id: name,
    name: name,
    multiline: true,
    variant: variant,
    rows: rows,
    label: label,
    value: value,
    onChange: onChange,
    className: setClass(classes, variant),
    style: {
      width: setWidth(width, other.fullWidth)
    }
  }, other));
};

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  variant: PropTypes.string,
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  width: PropTypes.number,
  outlineColor: PropTypes.string,
  fillColor: PropTypes.string,
  labelColor: PropTypes.string
};
var useStyles$4 = makeStyles(function (theme) {
  return {
    FormControl: {
      margin: theme.spacing(1),
      minWidth: 150,
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    outlinedFormControl: {
      margin: theme.spacing(1),
      minWidth: 150,
      "& fieldset": {
        borderColor: function borderColor(props) {
          return setInputColor(props.outlineColor, theme);
        },
        borderWidth: 1.5
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    filledFormControl: {
      margin: theme.spacing(1),
      minWidth: 150,
      "& div": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.85);
        }
      },
      "& div:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& div:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& input:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& input:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    }
  };
});

var SingleSelectFilter = function SingleSelectFilter(props) {
  var name = props.name,
      label = props.label,
      valueField = props.valueField,
      displayField = props.displayField,
      _props$data = props.data,
      data = _props$data === undefined ? [] : _props$data,
      _props$value = props.value,
      value = _props$value === undefined ? "" : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === undefined ? "standard" : _props$variant,
      onChange = props.onChange,
      width = props.width,
      outlineColor = props.outlineColor,
      fillColor = props.fillColor,
      labelColor = props.labelColor,
      other = objectWithoutProperties(props, ["name", "label", "valueField", "displayField", "data", "value", "variant", "onChange", "width", "outlineColor", "fillColor", "labelColor"]);
  var classes = useStyles$4({
    outlineColor: outlineColor,
    fillColor: fillColor,
    labelColor: labelColor
  });
  return React.createElement(FormControl, _extends({
    className: setClass(classes, variant, "FormControl"),
    variant: variant,
    style: {
      width: setWidth(width, other.fullWidth)
    }
  }, other), React.createElement(InputLabel, {
    id: name
  }, label), React.createElement(Select, {
    "data-testid": "single-select",
    labelId: name + "-label",
    id: name,
    name: name,
    label: label,
    value: value,
    onChange: onChange
  }, data.map(function (val) {
    return React.createElement(MenuItem, {
      key: val[valueField],
      value: val[valueField]
    }, val[displayField]);
  })));
};

SingleSelectFilter.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  valueField: PropTypes.string.isRequired,
  displayField: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  variant: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.number,
  outlineColor: PropTypes.string,
  fillColor: PropTypes.string,
  labelColor: PropTypes.string
};
var useStyles$5 = makeStyles(function (theme) {
  return {
    FormControl: {
      margin: theme.spacing(1),
      minWidth: 150,
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    outlinedFormControl: {
      margin: theme.spacing(1),
      minWidth: 150,
      "& fieldset": {
        borderColor: function borderColor(props) {
          return setInputColor(props.outlineColor, theme);
        },
        borderWidth: 1.5
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    filledFormControl: {
      margin: theme.spacing(1),
      minWidth: 150,
      "& div": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.85);
        }
      },
      "& div:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& div:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        }
      },
      "& input:hover": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& input:focus": {
        backgroundColor: function backgroundColor(props) {
          return setInputColor(props.fillColor, theme, 0.75);
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      "& label": {
        color: function color(props) {
          return setInputColor(props.labelColor, theme);
        }
      }
    },
    controls: {
      position: "absolute",
      bottom: 0
    }
  };
});
var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5.5 + ITEM_PADDING_TOP,
      minWidth: 250
    }
  }
};

var MultiSelect = function MultiSelect(props) {
  var name = props.name,
      label = props.label,
      valueField = props.valueField,
      displayField = props.displayField,
      _props$data = props.data,
      data = _props$data === undefined ? [] : _props$data,
      _props$value = props.value,
      value = _props$value === undefined ? "" : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === undefined ? "standard" : _props$variant,
      onChange = props.onChange,
      width = props.width,
      outlineColor = props.outlineColor,
      fillColor = props.fillColor,
      labelColor = props.labelColor,
      other = objectWithoutProperties(props, ["name", "label", "valueField", "displayField", "data", "value", "variant", "onChange", "width", "outlineColor", "fillColor", "labelColor"]);
  var classes = useStyles$5({
    outlineColor: outlineColor,
    fillColor: fillColor,
    labelColor: labelColor
  });
  /**
   * Function used to render the text associated with the currently
   * selected values
   * Without this function, the ndx value is displayed instead of the text
   * @param {*} selections
   */

  var setSelectedText = function setSelectedText(selections) {
    var textValues = data.filter(function (d) {
      return selections.includes(d[valueField]);
    }).map(function (d) {
      return d[displayField];
    });
    return textValues.join(", ");
  };
  /**
   * Event handler for the MultiSelect
   * This handler is necessary for implementing the select all/none
   * custom controls
   * @param {object} event JavaScript Event Object
   */


  var handleChange = function handleChange(event) {
    var _event$target = event.target,
        value = _event$target.value,
        name = _event$target.name;
    var text = event.nativeEvent.target.textContent;

    if (value.includes("all/none") && text === "Select All") {
      handleSelectAll(name);
    } else if (value.includes("all/none") && text === "Select None") {
      handleSelectNone(name);
    } else {
      onChange(event);
    }
  };
  /**
   * Event handler for selecting all values in dropdown
   * @param {string} name select name attribute value
   */


  var handleSelectAll = function handleSelectAll(name) {
    onChange({
      target: {
        name: name,
        value: data.map(function (d) {
          return d[valueField];
        })
      }
    });
  };
  /**
   * Event handler for de-selecting all values in dropdown
   * @param {string} name select name attribute value
   */


  var handleSelectNone = function handleSelectNone(name) {
    onChange({
      target: {
        name: name,
        value: []
      }
    });
  };

  return React.createElement(FormControl, _extends({
    className: setClass(classes, variant, "FormControl"),
    variant: variant,
    style: {
      width: setWidth(width, other.fullWidth)
    }
  }, other), React.createElement(InputLabel, {
    id: name
  }, label), React.createElement(Select, {
    "data-testid": "multi-select",
    labelId: name + "-label",
    id: name,
    name: name,
    label: label,
    multiple: true,
    value: value,
    onChange: handleChange,
    renderValue: function renderValue(selections) {
      return setSelectedText(selections);
    },
    MenuProps: MenuProps
  }, data.length > 0 && React.createElement(MenuItem, {
    value: "all/none"
  }, React.createElement(Button, {
    color: "primary"
  }, "Select All"), React.createElement(Button, {
    color: "primary"
  }, "Select None")), data.length > 0 && React.createElement(Divider, null), data.map(function (val) {
    return React.createElement(MenuItem, {
      key: val[valueField],
      value: val[valueField]
    }, React.createElement(Checkbox, {
      color: "primary",
      checked: value.indexOf(val[valueField]) > -1
    }), React.createElement(ListItemText, {
      primary: val[displayField]
    }));
  })));
};

MultiSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  valueField: PropTypes.string.isRequired,
  displayField: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  variant: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.number,
  outlineColor: PropTypes.string,
  fillColor: PropTypes.string,
  labelColor: PropTypes.string
};

var useVisibility = function useVisibility() {
  var defaultVisibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(defaultVisibility),
      _useState2 = slicedToArray(_useState, 2),
      visibility = _useState2[0],
      setVisibility = _useState2[1];

  var handleVisibility = function handleVisibility(event, vis) {
    if (typeof vis !== "undefined") {
      setVisibility(vis);
    } else {
      setVisibility(function (state) {
        return !state;
      });
    }
  };

  return [visibility, handleVisibility];
};

var useStyles$6 = makeStyles(function (theme) {
  return {
    margin: {
      margin: theme.spacing(2)
    },
    moreFilters: {
      width: "100%"
    },
    divider: {
      margin: theme.spacing(2, 0)
    }
  };
});

var FilterAdvanced = function FilterAdvanced(_ref) {
  var children = _ref.children;
  var classes = useStyles$6();

  var _useVisibility = useVisibility(false),
      _useVisibility2 = slicedToArray(_useVisibility, 2),
      visibility = _useVisibility2[0],
      handleVisibility = _useVisibility2[1];

  return React.createElement(React.Fragment, null, React.createElement(Button, {
    color: "primary",
    className: classes.margin,
    onClick: handleVisibility
  }, React.createElement(TuneIcon, {
    style: {
      marginRight: 5
    }
  }), visibility ? "Less Filters" : "More Filters"), React.createElement(Collapse, {
    "in": visibility,
    className: classes.moreFilters
  }, React.createElement(Divider, {
    className: classes.divider
  }), children));
};

FilterAdvanced.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
var useStyles$7 = makeStyles(function (theme) {
  return {
    root: {
      margin: theme.spacing(0, 1)
    }
  };
});

var Submit = function Submit(_ref) {
  var children = _ref.children;
  var classes = useStyles$7();
  return React.createElement("div", {
    className: classes.root
  }, children);
};

Submit.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
var useStyles$8 = makeStyles(function (theme) {
  return {
    root: {
      backgroundColor: "#ffffff",
      padding: theme.spacing(1),
      minHeight: 85,
      width: "100%"
    },
    filters: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap"
    },
    submit: {
      marginLeft: theme.spacing(1)
    }
  };
});

var FilterBar = function FilterBar(_ref) {
  var onSubmit = _ref.onSubmit,
      children = _ref.children;
  var classes = useStyles$8();
  return React.createElement(Box, {
    boxShadow: 1,
    className: classes.root
  }, React.createElement("form", {
    "data-testid": "filter-form",
    className: classes.filters,
    onSubmit: onSubmit
  }, children));
};

FilterBar.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var core = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  var isSafari = exports.isSafari = function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };

  var isJsons = exports.isJsons = function isJsons(array) {
    return Array.isArray(array) && array.every(function (row) {
      return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
    });
  };

  var isArrays = exports.isArrays = function isArrays(array) {
    return Array.isArray(array) && array.every(function (row) {
      return Array.isArray(row);
    });
  };

  var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
    return Array.from(array.map(function (json) {
      return Object.keys(json);
    }).reduce(function (a, b) {
      return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
    }, []));
  };

  var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
    headers = headers || jsonsHeaders(jsons);
    var headerLabels = headers;
    var headerKeys = headers;

    if (isJsons(headers)) {
      headerLabels = headers.map(function (header) {
        return header.label;
      });
      headerKeys = headers.map(function (header) {
        return header.key;
      });
    }

    var data = jsons.map(function (object) {
      return headerKeys.map(function (header) {
        return getHeaderValue(header, object);
      });
    });
    return [headerLabels].concat(_toConsumableArray(data));
  };

  var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
    var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
      if (o[p] === undefined) {
        arr.splice(1);
      } else {
        return o[p];
      }
    }, obj);
    return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
  };

  var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
    return element || element === 0 ? element : '';
  };

  var joiner = exports.joiner = function joiner(data) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
    var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
    return data.filter(function (e) {
      return e;
    }).map(function (row) {
      return row.map(function (element) {
        return elementOrEmpty(element);
      }).map(function (column) {
        return "" + enclosingCharacter + column + enclosingCharacter;
      }).join(separator);
    }).join("\n");
  };

  var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
    return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator, enclosingCharacter);
  };

  var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
    return joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
  };

  var string2csv = exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
    return headers ? headers.join(separator) + "\n" + data : data;
  };

  var toCSV = exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
    if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
    if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
    if (typeof data === 'string') return string2csv(data, headers, separator);
    throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
  };

  var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
    var csv = toCSV(data, headers, separator, enclosingCharacter);
    var type = isSafari() ? 'application/csv' : 'text/csv';
    var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], {
      type: type
    });
    var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;
    var URL = window.URL || window.webkitURL;
    return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
  };
});
unwrapExports(core);
var core_1 = core.isSafari;
var core_2 = core.isJsons;
var core_3 = core.isArrays;
var core_4 = core.jsonsHeaders;
var core_5 = core.jsons2arrays;
var core_6 = core.getHeaderValue;
var core_7 = core.elementOrEmpty;
var core_8 = core.joiner;
var core_9 = core.arrays2csv;
var core_10 = core.jsons2csv;
var core_11 = core.string2csv;
var core_12 = core.toCSV;
var core_13 = core.buildURI;
var metaProps = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;

  var _react2 = _interopRequireDefault(React);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var propTypes = exports.propTypes = {
    data: (0, PropTypes.oneOfType)([PropTypes.string, PropTypes.array]).isRequired,
    headers: PropTypes.array,
    target: PropTypes.string,
    separator: PropTypes.string,
    filename: PropTypes.string,
    uFEFF: PropTypes.bool,
    onClick: PropTypes.func,
    asyncOnClick: PropTypes.bool
  };
  var defaultProps = exports.defaultProps = {
    separator: ',',
    filename: 'generatedBy_react-csv.csv',
    uFEFF: true,
    asyncOnClick: false
  };
  var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];
});
unwrapExports(metaProps);
var metaProps_1 = metaProps.PropsNotForwarded;
var metaProps_2 = metaProps.defaultProps;
var metaProps_3 = metaProps.propTypes;
var Download = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(React);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var defaultProps = {
    target: '_blank'
  };

  var CSVDownload = function (_React$Component) {
    _inherits(CSVDownload, _React$Component);

    function CSVDownload(props) {
      _classCallCheck(this, CSVDownload);

      var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));

      _this.state = {};
      return _this;
    }

    _createClass(CSVDownload, [{
      key: 'buildURI',
      value: function buildURI() {
        return core.buildURI.apply(undefined, arguments);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            data = _props.data,
            headers = _props.headers,
            separator = _props.separator,
            enclosingCharacter = _props.enclosingCharacter,
            uFEFF = _props.uFEFF,
            target = _props.target,
            specs = _props.specs,
            replace = _props.replace;
        this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
      }
    }, {
      key: 'getWindow',
      value: function getWindow() {
        return this.state.page;
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return CSVDownload;
  }(_react2["default"].Component);

  CSVDownload.defaultProps = Object.assign(metaProps.defaultProps, defaultProps);
  CSVDownload.propTypes = metaProps.propTypes;
  exports["default"] = CSVDownload;
});
unwrapExports(Download);
var Link = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(React);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CSVLink = function (_React$Component) {
    _inherits(CSVLink, _React$Component);

    function CSVLink(props) {
      _classCallCheck(this, CSVLink);

      var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));

      _this.buildURI = _this.buildURI.bind(_this);
      _this.state = {
        href: ''
      };
      return _this;
    }

    _createClass(CSVLink, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            data = _props.data,
            headers = _props.headers,
            separator = _props.separator,
            uFEFF = _props.uFEFF,
            enclosingCharacter = _props.enclosingCharacter;
        this.setState({
          href: this.buildURI(data, uFEFF, headers, separator, enclosingCharacter)
        });
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
          var data = prevProps.data,
              headers = prevProps.headers,
              separator = prevProps.separator,
              uFEFF = prevProps.uFEFF;
          this.setState({
            href: this.buildURI(data, uFEFF, headers, separator)
          });
        }
      }
    }, {
      key: 'buildURI',
      value: function buildURI() {
        return core.buildURI.apply(undefined, arguments);
      }
    }, {
      key: 'handleLegacy',
      value: function handleLegacy(event) {
        if (window.navigator.msSaveOrOpenBlob) {
          event.preventDefault();
          var _props2 = this.props,
              data = _props2.data,
              headers = _props2.headers,
              separator = _props2.separator,
              filename = _props2.filename,
              enclosingCharacter = _props2.enclosingCharacter,
              uFEFF = _props2.uFEFF;
          var blob = new Blob([uFEFF ? "\uFEFF" : '', (0, core.toCSV)(data, headers, separator, enclosingCharacter)]);
          window.navigator.msSaveBlob(blob, filename);
          return false;
        }
      }
    }, {
      key: 'handleAsyncClick',
      value: function handleAsyncClick(event) {
        var _this2 = this;

        var done = function done(proceed) {
          if (proceed === false) {
            event.preventDefault();
            return;
          }

          _this2.handleLegacy(event);
        };

        this.props.onClick(event, done);
      }
    }, {
      key: 'handleSyncClick',
      value: function handleSyncClick(event) {
        var stopEvent = this.props.onClick(event) === false;

        if (stopEvent) {
          event.preventDefault();
          return;
        }

        this.handleLegacy(event);
      }
    }, {
      key: 'handleClick',
      value: function handleClick() {
        var _this3 = this;

        return function (event) {
          if (typeof _this3.props.onClick === 'function') {
            return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
          }

          _this3.handleLegacy(event);
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props3 = this.props,
            data = _props3.data,
            headers = _props3.headers,
            separator = _props3.separator,
            filename = _props3.filename,
            uFEFF = _props3.uFEFF,
            children = _props3.children,
            onClick = _props3.onClick,
            asyncOnClick = _props3.asyncOnClick,
            enclosingCharacter = _props3.enclosingCharacter,
            rest = _objectWithoutProperties(_props3, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick', 'enclosingCharacter']);

        return _react2["default"].createElement('a', _extends({
          download: filename
        }, rest, {
          ref: function ref(link) {
            return _this4.link = link;
          },
          target: '_self',
          href: this.state.href,
          onClick: this.handleClick()
        }), children);
      }
    }]);

    return CSVLink;
  }(_react2["default"].Component);

  CSVLink.defaultProps = metaProps.defaultProps;
  CSVLink.propTypes = metaProps.propTypes;
  exports["default"] = CSVLink;
});
unwrapExports(Link);
var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CSVLink = exports.CSVDownload = undefined;

  var _Download2 = _interopRequireDefault(Download);

  var _Link2 = _interopRequireDefault(Link);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var CSVDownload = exports.CSVDownload = _Download2["default"];
  var CSVLink = exports.CSVLink = _Link2["default"];
});
unwrapExports(lib);
var lib_1 = lib.CSVLink;
var lib_2 = lib.CSVDownload;
var reactCsv = lib;

var useTable = function useTable(data, columns) {
  var _useState = useState("desc"),
      _useState2 = slicedToArray(_useState, 2),
      order = _useState2[0],
      setOrder = _useState2[1];

  var _useState3 = useState("Date"),
      _useState4 = slicedToArray(_useState3, 2),
      orderBy = _useState4[0],
      setOrderBy = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = slicedToArray(_useState5, 2),
      filteredKeys = _useState6[0],
      setFilteredKeys = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = slicedToArray(_useState7, 2),
      filters = _useState8[0],
      setFilters = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = slicedToArray(_useState9, 2),
      excludeNulls = _useState10[0],
      setExcludeNulls = _useState10[1];
  /**
   * Return an array of the header labels
   * Updates whenever the columns or filtered columns change
   */


  var headers = useMemo(function () {
    if (columns.length > 0) {
      return columns.filter(function (col) {
        return filteredKeys.includes(col.accessor);
      }).map(function (col) {
        return col.label;
      });
    }

    return [];
  }, [columns, filteredKeys]);
  /**
   * Return an array of the column keys
   * Updates whenever the columns or filtered columns change
   */

  var keys = useMemo(function () {
    if (columns.length > 0) {
      return columns.filter(function (col) {
        return filteredKeys.includes(col.accessor);
      }).map(function (col) {
        return col.accessor;
      });
    }

    return [];
  }, [columns, filteredKeys]);
  /**
   * Utility function used to sort the data by a specified field and direction
   * @param {array} data array of objects to sort
   * @param {*} order direction to sort i.e. asc or desc
   * @param {*} orderBy field to order the data by
   */

  var sort = function sort(data, order, orderBy) {
    var sorted = stableSort(data, getSorting(order, orderBy));
    return sorted;
  };
  /**
   * Event handler that can be attached to trigger a sort
   * @param {string} property the name of object property to sort by
   */


  var handleSort = function handleSort(property) {
    var isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };
  /**
   * Initialize the columns so that are all toggled on initially
   */


  var initFilteredColumns = useCallback(function () {
    var columnKeys = columns.filter(function (col) {
      return col.columnToggle.enabled;
    }).map(function (col) {
      return col.accessor;
    });
    setFilteredKeys(columnKeys);
  }, [columns]);
  /**
   * Run the initFilteredColumns useCallback hook
   */

  useEffect(function () {
    initFilteredColumns();
  }, [initFilteredColumns]);
  /**
   * Event handler that can be attached to a component to trigger
   * toggling columns on and off
   * @param {*} keys
   */

  var handleFilteredKeys = function handleFilteredKeys(keys) {
    setFilteredKeys(keys);
  };
  /**
   * Return an array of the columns that are toggled on
   */


  var columnToggles = useMemo(function () {
    return columns.filter(function (col) {
      return col.columnToggle.enabled;
    });
  }, [columns]);
  /**
   * Utility function used to add/remove columns that are toggled on/off
   * from the data table
   * @param {array} data array of objects to affect
   * @param {array} keys full list of fields present in the dataset
   * @param {array} filteredKeys filtered list of fields for the columns that are toggled on
   */

  var toggleColumns = function toggleColumns(data, keys, filteredKeys) {
    return data.map(function (d) {
      var record = {};
      keys.forEach(function (key) {
        if (filteredKeys.includes(key)) {
          record[key] = d[key];
        }
      });
      return record;
    });
  };
  /**
   * Utility function used to configure the table filters
   */


  var setInitFilters = useCallback(function () {
    if (data.length > 0) {
      var initialFilters = columns.filter(function (col) {
        return col.filter.enabled && filteredKeys.includes(col.accessor);
      }).map(function (col) {
        var filter = _extends({}, col);

        var type = filter.filter.type;

        if (type === "date") {
          var dates = data.map(function (d) {
            return d[col.accessor];
          });
          filter.filter.value = [];
          filter.filter.value.push(dates.reduce(function (a, b) {
            return a < b ? a : b;
          }));
          filter.filter.value.push(dates.reduce(function (a, b) {
            return a > b ? a : b;
          }));
          filter.filter.min = filter.filter.value[0];
          filter.filter.max = filter.filter.value[1];
        }

        return filter;
      });
      setFilters(initialFilters);
    } else {
      setFilters([]);
    }
  }, [data, columns, filteredKeys]);
  /**
   * Run the setInitFilters useCallback hook
   */

  useEffect(function () {
    setInitFilters();
  }, [setInitFilters]);
  /**
   * Function used to filter the data to match the user's current selections
   * @param {array} data array of objects to affect
   * @param {array} filters filters to apply to the data
   * @param {array} filteredKeys filters to apply to the data
   */

  var filterData = function filterData(data, filters, filteredKeys) {
    var filteredData = [].concat(toConsumableArray(data));
    filters.forEach(function (filter) {
      filteredData = filteredData.filter(function (d) {
        if (filteredKeys.includes(filter.accessor)) {
          if (filter.filter.type === "date") {
            return d[filter.accessor] >= filter.filter.value[0] && d[filter.accessor] <= filter.filter.value[1];
          } else {
            return filter.filter.value.includes(d[filter.accessor]);
          }
        }

        return true;
      });
    });
    return filteredData;
  };
  /**
   * Event handler that can be attached to a component to handle filter changes
   * @param {object} event JavaScript event object
   */


  var handleFilteredValues = function handleFilteredValues(event) {
    var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
    setFilters(function (prevState) {
      var newFilters = [].concat(toConsumableArray(prevState));
      newFilters.forEach(function (filter) {
        if (filter.accessor + "_start" === name) {
          filter.filter.value[0] = value;
        } else if (filter.accessor + "_end" === name) {
          filter.filter.value[1] = value;
        } else if (filter.accessor === name) {
          filter.filter.value = value;
        }
      });
      return newFilters;
    });
  };
  /**
   * Function used to exclude nulls from dataset if the
   * exclude nulls option is true
   * @param {array} data array of objects to be filtered
   * @param {array} columns array of column configs
   * @param {array} filteredKeys array of column keys that are currently toggled on
   * @param {boolean} excludeNulls boolean indicating if nulls should be excluded
   */


  var excludeNullData = function excludeNullData(data, columns, filteredKeys, excludeNulls) {
    if (excludeNulls) {
      var seriesFields = columns.filter(function (col) {
        return col.type === "series" && filteredKeys.includes(col.accessor);
      }).map(function (col) {
        return col.accessor;
      });
      return data.filter(function (d) {
        var nullCount = 0;
        seriesFields.forEach(function (field) {
          if (d[field] === null || d[field] === "") {
            nullCount = nullCount + 1;
          }
        });
        return nullCount !== seriesFields.length;
      });
    }

    return data;
  };
  /**
   * Handler for updating the exclude nulls state that can be
   * attached to a component
   */


  var handleExcludeNulls = function handleExcludeNulls() {
    setExcludeNulls(function (state) {
      return !state;
    });
  };
  /**
   * Logic surrounding updating the tableData value
   * The toggle column selections are applied first,
   * then the data is filterd,
   * next if nulls are set to be excluded they are removed,
   * and lastly the data is sorted
   */


  var tableData = useMemo(function () {
    var selectedColumnsData = toggleColumns(data, keys, filteredKeys);
    var filteredData = filterData(selectedColumnsData, filters, filteredKeys);
    var excludedNullsData = excludeNullData(filteredData, columns, filteredKeys, excludeNulls);
    return sort(excludedNullsData, order, orderBy);
  }, [data, keys, filteredKeys, filters, columns, excludeNulls, order, orderBy]);
  return {
    headers: headers,
    keys: keys,
    excludeNulls: excludeNulls,
    filters: filters,
    columnToggles: columnToggles,
    filteredKeys: filteredKeys,
    tableData: tableData,
    order: order,
    orderBy: orderBy,
    handleSort: handleSort,
    handleFilteredKeys: handleFilteredKeys,
    handleFilteredValues: handleFilteredValues,
    handleExcludeNulls: handleExcludeNulls
  };
};

var useStyles$9 = makeStyles(function (theme) {
  return {
    filters: {
      padding: 15,
      marginBottom: 30,
      backgroundColor: "#f9f9f9"
    },
    textField: {
      marginTop: 15,
      marginRight: 15,
      minWidth: 120,
      maxWidth: 200
    },
    formControl: {
      marginTop: 15,
      marginRight: 15,
      minWidth: 120,
      maxWidth: 200
    }
  };
});

var Filters = function Filters(_ref) {
  var filters = _ref.filters,
      visible = _ref.visible,
      visibilityHandler = _ref.visibilityHandler,
      handleFilter = _ref.handleFilter;
  var classes = useStyles$9();

  var constructFilter = function constructFilter(filter) {
    if (filter.filter.type === "date") {
      var error = filter.filter.value[0] > filter.filter.max || filter.filter.value[0] < filter.filter.min || filter.filter.value[1] > filter.filter.max || filter.filter.value[1] < filter.filter.min;
      return React.createElement(React.Fragment, null, React.createElement(TextField, {
        id: "start-date",
        variant: "outlined",
        label: "Start Date",
        type: "date",
        error: error,
        helperText: error ? "Out of range date." : "",
        min: filter.filter.min,
        max: filter.filter.max,
        name: filter.accessor + "_start",
        value: filter.filter.value[0],
        className: classes.textField,
        onChange: handleFilter,
        InputLabelProps: {
          shrink: true
        }
      }), React.createElement(TextField, {
        id: "end-date",
        variant: "outlined",
        label: "End Date",
        type: "date",
        name: filter.accessor + "_end",
        error: error,
        helperText: error ? "Out of range date." : "",
        min: filter.filter.min,
        max: filter.filter.max,
        value: filter.filter.value[1],
        className: classes.textField,
        onChange: handleFilter,
        InputLabelProps: {
          shrink: true
        }
      }));
    }
  };

  return React.createElement(Collapse, {
    "in": visible
  }, React.createElement("div", {
    className: classes.filters
  }, React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true,
    display: "inline"
  }, "Table Filters"), React.createElement(Button, {
    onClick: visibilityHandler
  }, "Hide"), React.createElement("form", null, filters.map(function (filter) {
    return React.createElement("div", {
      key: filter.accessor
    }, constructFilter(filter));
  }))));
};

Filters.propTypes = {
  filters: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  visibilityHandler: PropTypes.func.isRequired,
  handleFilter: PropTypes.func.isRequired
};
var useStyles$a = makeStyles(function (theme) {
  return {
    filters: {
      padding: 15,
      marginBottom: 30,
      backgroundColor: "#f9f9f9"
    },
    formControl: {
      marginTop: 15,
      marginRight: 15,
      minWidth: 120,
      maxWidth: 200
    }
  };
});

var ColumnToggles = function ColumnToggles(_ref) {
  var columns = _ref.columns,
      visible = _ref.visible,
      selections = _ref.selections,
      visibilityHandler = _ref.visibilityHandler,
      handleToggle = _ref.handleToggle;
  var classes = useStyles$a();

  var handleFilter = function handleFilter(event) {
    handleToggle(event.target.value);
  };

  return React.createElement(Collapse, {
    "in": visible
  }, React.createElement("div", {
    className: classes.filters
  }, React.createElement(Typography, {
    variant: "h6",
    display: "inline",
    gutterBottom: true
  }, "Toggle Columns"), React.createElement(Button, {
    onClick: visibilityHandler
  }, "Hide"), React.createElement("div", null, React.createElement(MultiSelect, {
    name: "columns",
    label: "Columns",
    valueField: "accessor",
    displayField: "label",
    data: columns,
    value: selections,
    variant: "outlined",
    onChange: handleFilter,
    width: 250
  }))));
};

ColumnToggles.propTypes = {
  columns: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  selections: PropTypes.array.isRequired,
  visibilityHandler: PropTypes.func.isRequired,
  handleToggle: PropTypes.func.isRequired
};

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.329 482.312l43.077-68.36-43.097 75.807-.023 7.79q-4.61-.054-9.127-.354l3.514-100.062-.046-.774.079-.148.334-9.455L0 311.833l45.087 67.842.135 2.003 2.654-75.601-38.72-77.518 39.023 64.233 1.815-156.7.008-.522.006.513.884 123.548 37-49.433-37.033 60.074-.171 67.668 34.33-65.354-34.35 75.303-.094 37.627 49.867-90.997-49.907 104.123z",
  fill: "#d0cde1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M642.851 193.767h12.11v85.984h-12.11z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M202.283 22.001l4.554-11.22 448.149 181.896-4.554 11.221z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1002.5 493.693C983.741 525.03-.99 522.4.502 493.691c18.757-31.335 1003.488-28.704 1001.996.002z",
  fill: "#d0cde1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M773.644 366.947h105.361v41.176H773.644z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M349.778 403.278h519.539v46.02H349.778z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#d0cde1",
  d: "M783.938 426.288H659.2v-156.83h93.251l31.487 79.097v77.733z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M678.577 279.146h53.286v53.286h-53.286zM771.827 333.038h-33.909v-53.286h14.533l19.376 53.286z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M680.999 362.708h12.11v23.01h-12.11zM748.212 313.661h.606a11.505 11.505 0 0111.504 11.505 11.505 11.505 0 01-11.504 11.505h-.606v-23.01zM297.703 403.278h.605a11.505 11.505 0 0111.505 11.505 11.505 11.505 0 01-11.505 11.505h-.605v-23.01z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M832.38 403.105c18.455 0 35.054 8.94 46.572 23.183h23.668l-23.01-64.096-107.177-21.138 3.028 85.234h10.346c11.518-14.243 28.118-23.183 46.573-23.183z",
  fill: "#d0cde1"
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 833.591,
  cy: 441.426,
  r: 52.681,
  fill: "#3f3d56"
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 833.591,
  cy: 441.426,
  r: 27.727,
  fill: "#d0cde1"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 357.65,
  cy: 447.482,
  r: 46.02,
  fill: "#3f3d56"
});

var _ref14 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 357.65,
  cy: 447.482,
  r: 24.221,
  fill: "#d0cde1"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M637.401 247.659h25.432v183.474h-25.432z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M297.097 397.829h365.736v10.899H297.097zM101.372 437.83l398.86-108.514 2.861 10.517-398.86 108.514z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M466.176 347.557l6.831-5.02 41.959 57.096-6.83 5.02zM743.368 335.46h12.11v4.844h-12.11z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M648.906 371.791H490.26a1.21 1.21 0 01-.344-2.372l155.014-46.02a1.21 1.21 0 011.552 1.066l3.633 46.02a1.211 1.211 0 01-1.208 1.306zm-150.313-2.422h149.003l-3.412-43.222zM219.3 318.505h-.012l-34.766-.327a1.211 1.211 0 01-1.192-1.35l18.064-157.614a1.211 1.211 0 011.203-1.074h.006a1.212 1.212 0 011.199 1.084l16.702 157.943a1.211 1.211 0 01-1.205 1.338zm-33.41-2.737l32.062.302-15.403-145.66zM887.528 384.649l-.567.214a11.505 11.505 0 01-14.83-6.691 11.505 11.505 0 016.69-14.83l.567-.215 8.14 21.522zM117.097 401.167l33.782-9.456 1.5 5.362-33.78 9.456z",
  fill: "#3f3d56"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M395.503 324.686l-6.52 3.56-264.894 74.144-3.932-4.885a58.171 58.171 0 01-12.581-29.144c-1-7.985-.27-16.4 5.3-21.523l-10.115-81.59 146.5-41.204 69.485 29.899s26.616-7.953 46.202 6.08c6.2 4.446 11.698 11.094 15.416 20.907l3.203 9.252z",
  fill: "#6c63ff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 336.948,
  cy: 339.63,
  r: 33.967,
  fill: "#3f3d56"
});

var _ref21 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 336.948,
  cy: 339.63,
  r: 17.877,
  fill: "#d0cde1"
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 175.545,
  cy: 384.807,
  r: 33.967,
  fill: "#3f3d56"
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 175.545,
  cy: 384.807,
  r: 17.877,
  fill: "#d0cde1"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M294.724 254.884l-105.1 29.418-8.855-31.637 67.028-18.762 46.927 20.981zM126.075 267.974l41.825-11.707 8.855 31.637-41.825 11.707z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3f3d56",
  d: "M196.229 307.895l5.362-1.5 2.851 10.188-5.362 1.5zM286.014 267.151l1.501 5.362-10.188 2.852-1.501-5.362z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M273.967 248.898l.59-.165a11.638 11.638 0 0114.343 8.07 11.638 11.638 0 01-8.07 14.344l-.59.165-6.273-22.414zM383.567 290.182a17.988 17.988 0 01-18.619-30.16c6.2 4.447 11.698 11.095 15.416 20.908zM195.975 10.899h12.11v176.813h-12.11z",
  fill: "#3f3d56"
});

var _ref27 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 202.03,
  cy: 16.955,
  r: 16.955,
  fill: "#3f3d56"
});

var _ref28 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 648.906,
  cy: 196.189,
  r: 16.955,
  fill: "#3f3d56"
});

var NoDataIllustration = "data:image/svg+xml,%3Csvg%20id%3D%22bf6b072d-b0c7-410f-9e86-e550d19ff3f5%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%221002.5009%22%20height%3D%22516.22024%22%20viewBox%3D%220%200%201002.5009%20516.22024%22%3E%3Ctitle%3Etowing%3C%2Ftitle%3E%3Cpath%20d%3D%22M149.07843%2C674.20215l43.07664-68.361-43.09661%2C75.80813-.02309%2C7.7894q-4.60974-.0539-9.12643-.35342l3.51352-100.06285-.0462-.77342.07916-.14767.33455-9.45528L98.74955%2C503.72254l45.08688%2C67.8427.1349%2C2.00269%2C2.65414-75.6014-38.7204-77.518%2C39.023%2C64.23377%2C1.8152-156.70073.00832-.52151.00624.51318.88382%2C123.54783%2C36.99947-49.43346L149.60894%2C462.1622l-.17171%2C67.668%2C34.33009-65.354-34.349%2C75.30247-.095%2C37.62683%2C49.86758-90.99615L149.284%2C590.5318Z%22%20transform%3D%22translate%28-98.74955%20-191.88988%29%22%20fill%3D%22%23d0cde1%22%2F%3E%3Crect%20x%3D%22642.85096%22%20y%3D%22193.7674%22%20width%3D%2212.11046%22%20height%3D%2285.98428%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22521.32907%22%20y%3D%2257.40029%22%20width%3D%2212.11046%22%20height%3D%22483.65711%22%20transform%3D%22translate%28-46.96838%20483.46895%29%20rotate%28-67.90849%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M1101.24876%2C685.58308C1082.49147%2C716.92037%2C97.76%2C714.2897%2C99.25214%2C685.58122%2C118.00918%2C654.24579%2C1102.7407%2C656.87647%2C1101.24876%2C685.58308Z%22%20transform%3D%22translate%28-98.74955%20-191.88988%29%22%20fill%3D%22%23d0cde1%22%2F%3E%3Crect%20x%3D%22773.64395%22%20y%3D%22366.94701%22%20width%3D%22105.36102%22%20height%3D%2241.17557%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22349.77776%22%20y%3D%22403.2784%22%20width%3D%22519.53884%22%20height%3D%2246.01976%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpolygon%20points%3D%22783.938%20426.288%20659.2%20426.288%20659.2%20269.458%20752.451%20269.458%20783.938%20348.555%20783.938%20426.288%22%20fill%3D%22%23d0cde1%22%2F%3E%3Crect%20x%3D%22678.57682%22%20y%3D%22279.14616%22%20width%3D%2253.28603%22%20height%3D%2253.28603%22%20fill%3D%22%23fff%22%2F%3E%3Cpolygon%20points%3D%22771.827%20333.038%20737.918%20333.038%20737.918%20279.752%20752.451%20279.752%20771.827%20333.038%22%20fill%3D%22%23fff%22%2F%3E%3Crect%20x%3D%22680.99891%22%20y%3D%22362.70835%22%20width%3D%2212.11046%22%20height%3D%2223.00988%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M748.212%2C313.661h.60553a11.50493%2C11.50493%2C0%2C0%2C1%2C11.50493%2C11.50493v0a11.50493%2C11.50493%2C0%2C0%2C1-11.50493%2C11.50493H748.212a0%2C0%2C0%2C0%2C1%2C0%2C0V313.661a0%2C0%2C0%2C0%2C1%2C0%2C0Z%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M297.70277%2C403.2784h.60553a11.50493%2C11.50493%2C0%2C0%2C1%2C11.50493%2C11.50493v0a11.50493%2C11.50493%2C0%2C0%2C1-11.50493%2C11.50493h-.60553a0%2C0%2C0%2C0%2C1%2C0%2C0V403.2784A0%2C0%2C0%2C0%2C1%2C297.70277%2C403.2784Z%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M931.12924%2C594.99452c18.45486%2C0%2C35.05463%2C8.94049%2C46.5728%2C23.18364h23.66789l-23.00988-64.09594-107.1776-21.138%2C3.02762%2C85.234h10.34637C896.07461%2C603.935%2C912.67439%2C594.99452%2C931.12924%2C594.99452Z%22%20transform%3D%22translate%28-98.74955%20-191.88988%29%22%20fill%3D%22%23d0cde1%22%2F%3E%3Ccircle%20cx%3D%22833.59074%22%20cy%3D%22441.42636%22%20r%3D%2252.68051%22%20fill%3D%22%233f3d56%22%2F%3E%3Ccircle%20cx%3D%22833.59074%22%20cy%3D%22441.42636%22%20r%3D%2227.72659%22%20fill%3D%22%23d0cde1%22%2F%3E%3Ccircle%20cx%3D%22357.64956%22%20cy%3D%22447.48159%22%20r%3D%2246.01976%22%20fill%3D%22%233f3d56%22%2F%3E%3Ccircle%20cx%3D%22357.64956%22%20cy%3D%22447.48159%22%20r%3D%2224.22092%22%20fill%3D%22%23d0cde1%22%2F%3E%3Crect%20x%3D%22637.40125%22%20y%3D%22247.65896%22%20width%3D%2225.43197%22%20height%3D%22183.47351%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22297.09725%22%20y%3D%22397.82869%22%20width%3D%22365.73597%22%20height%3D%2210.89942%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22194.30308%22%20y%3D%22575.27158%22%20width%3D%22413.35786%22%20height%3D%2210.89942%22%20transform%3D%22translate%28-237.13545%20-66.25763%29%20rotate%28-15.21949%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22585.08165%22%20y%3D%22530.05667%22%20width%3D%228.47732%22%20height%3D%2270.85626%22%20transform%3D%22translate%28-319.17476%20266.90058%29%20rotate%28-36.31135%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22743.36779%22%20y%3D%22335.45981%22%20width%3D%2212.11046%22%20height%3D%224.84418%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M747.65574%2C563.68108H589.00868a1.21092%2C1.21092%2C0%2C0%2C1-.34416-2.37183l155.01392-46.01976a1.21074%2C1.21074%2C0%2C0%2C1%2C1.55166%2C1.06558l3.63314%2C46.01976a1.21143%2C1.21143%2C0%2C0%2C1-1.2075%2C1.30625ZM597.3429%2C561.259H746.34535l-3.412-43.22217Z%22%20transform%3D%22translate%28-98.74955%20-191.88988%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M318.04891%2C510.395h-.01124l-34.76613-.3276a1.2112%2C1.2112%2C0%2C0%2C1-1.19213-1.34882l18.064-157.61519a1.21146%2C1.21146%2C0%2C0%2C1%2C1.20336-1.07326h.00532a1.21158%2C1.21158%2C0%2C0%2C1%2C1.19922%2C1.08391l16.70215%2C157.94278a1.21129%2C1.21129%2C0%2C0%2C1-1.20454%2C1.33818Zm-33.40962-2.73668%2C32.06257.30158L301.29827%2C362.2997Z%22%20transform%3D%22translate%28-98.74955%20-191.88988%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M970.48825%2C556.4148h.60553a11.50493%2C11.50493%2C0%2C0%2C1%2C11.50493%2C11.50493v0a11.50493%2C11.50493%2C0%2C0%2C1-11.50493%2C11.50493h-.60553a0%2C0%2C0%2C0%2C1%2C0%2C0V556.4148A0%2C0%2C0%2C0%2C1%2C970.48825%2C556.4148Z%22%20transform%3D%22translate%281992.09742%20561.76549%29%20rotate%28159.28262%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22215.94814%22%20y%3D%22588.22581%22%20width%3D%2235.08027%22%20height%3D%225.5683%22%20transform%3D%22translate%28-249.4105%20-107.08039%29%20rotate%28-15.63709%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M494.25243%2C516.57572l-6.5206%2C3.55983L222.83891%2C594.27986l-3.93276-4.88514a58.17112%2C58.17112%2C0%2C0%2C1-12.58107-29.144c-1.00026-7.98461-.26866-16.40044%2C5.30138-21.52286l-10.11625-81.59017%2C146.50027-41.20421%2C69.48493%2C29.899s26.616-7.953%2C46.20245%2C6.08c6.19992%2C4.44595%2C11.698%2C11.09472%2C15.416%2C20.90745l3.20251%2C9.25159Z%22%20transform%3D%22translate%28-98.74955%20-191.88988%29%22%20fill%3D%22%236c63ff%22%2F%3E%3Ccircle%20cx%3D%22336.94773%22%20cy%3D%22339.63002%22%20r%3D%2233.96661%22%20fill%3D%22%233f3d56%22%2F%3E%3Ccircle%20cx%3D%22336.94773%22%20cy%3D%22339.63002%22%20r%3D%2217.87716%22%20fill%3D%22%23d0cde1%22%2F%3E%3Ccircle%20cx%3D%22175.54536%22%20cy%3D%22384.80702%22%20r%3D%2233.96661%22%20fill%3D%22%233f3d56%22%2F%3E%3Ccircle%20cx%3D%22175.54536%22%20cy%3D%22384.80702%22%20r%3D%2217.87716%22%20fill%3D%22%23d0cde1%22%2F%3E%3Cpolygon%20points%3D%22294.724%20254.884%20189.624%20284.302%20180.769%20252.665%20247.797%20233.903%20294.724%20254.884%22%20fill%3D%22%23fff%22%2F%3E%3Crect%20x%3D%22228.44813%22%20y%3D%22453.4022%22%20width%3D%2243.43272%22%20height%3D%2232.85295%22%20transform%3D%22translate%28-216.12969%20-107.07056%29%20rotate%28-15.63709%29%22%20fill%3D%22%23fff%22%2F%3E%3Crect%20x%3D%22296.30078%22%20y%3D%22498.83899%22%20width%3D%225.5683%22%20height%3D%2210.57976%22%20transform%3D%22translate%28-223.56445%20-92.61487%29%20rotate%28-15.63709%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22377.63635%22%20y%3D%22457.85865%22%20width%3D%225.5683%22%20height%3D%2210.57976%22%20transform%3D%22translate%28625.13777%20-219.92039%29%20rotate%2874.36291%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M375.62632%2C438.70629h.61252A11.63773%2C11.63773%2C0%2C0%2C1%2C387.87657%2C450.344v0a11.63773%2C11.63773%2C0%2C0%2C1-11.63773%2C11.63773h-.61252a0%2C0%2C0%2C0%2C1%2C0%2C0V438.70629A0%2C0%2C0%2C0%2C1%2C375.62632%2C438.70629Z%22%20transform%3D%22translate%28-206.00747%20-72.32334%29%20rotate%28-15.63709%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Cpath%20d%3D%22M482.31639%2C482.07146a17.98812%2C17.98812%2C0%2C0%2C1-18.61853-30.159c6.19992%2C4.44595%2C11.698%2C11.09472%2C15.416%2C20.90745Z%22%20transform%3D%22translate%28-98.74955%20-191.88988%29%22%20fill%3D%22%233f3d56%22%2F%3E%3Crect%20x%3D%22195.97489%22%20y%3D%2210.89942%22%20width%3D%2212.11046%22%20height%3D%22176.81275%22%20fill%3D%22%233f3d56%22%2F%3E%3Ccircle%20cx%3D%22202.03012%22%20cy%3D%2216.95465%22%20r%3D%2216.95465%22%20fill%3D%22%233f3d56%22%2F%3E%3Ccircle%20cx%3D%22648.90619%22%20cy%3D%22196.18949%22%20r%3D%2216.95465%22%20fill%3D%22%233f3d56%22%2F%3E%3C%2Fsvg%3E";

var _ref$1 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  className: "bk",
  d: "M0 0h100v100H0z"
});

var _ref2$1 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "a",
  x: "-100%",
  y: "-100%",
  width: "300%",
  height: "300%"
}, React.createElement("feOffset", {
  result: "offOut",
  "in": "SourceGraphic"
}), React.createElement("feGaussianBlur", {
  result: "blurOut",
  "in": "offOut"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "blurOut"
})));

var _ref3$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 50s0 .5.1 1.4c0 .5.1 1 .2 1.7 0 .3.1.7.1 1.1.1.4.1.8.2 1.2.2.8.3 1.8.5 2.8.3 1 .6 2.1.9 3.2.3 1.1.9 2.3 1.4 3.5.5 1.2 1.2 2.4 1.8 3.7.3.6.8 1.2 1.2 1.9.4.6.8 1.3 1.3 1.9 1 1.2 1.9 2.6 3.1 3.7 2.2 2.5 5 4.7 7.9 6.7 3 2 6.5 3.4 10.1 4.6 3.6 1.1 7.5 1.5 11.2 1.6 4-.1 7.7-.6 11.3-1.6 3.6-1.2 7-2.6 10-4.6 3-2 5.8-4.2 7.9-6.7 1.2-1.2 2.1-2.5 3.1-3.7.5-.6.9-1.3 1.3-1.9.4-.6.8-1.3 1.2-1.9.6-1.3 1.3-2.5 1.8-3.7.5-1.2 1-2.4 1.4-3.5.3-1.1.6-2.2.9-3.2.2-1 .4-1.9.5-2.8.1-.4.1-.8.2-1.2 0-.4.1-.7.1-1.1.1-.7.1-1.2.2-1.7.1-.9.1-1.4.1-1.4V54.2c0 .4-.1.8-.1 1.2-.1.9-.2 1.8-.4 2.8-.2 1-.5 2.1-.7 3.3-.3 1.2-.8 2.4-1.2 3.7-.2.7-.5 1.3-.8 1.9-.3.7-.6 1.3-.9 2-.3.7-.7 1.3-1.1 2-.4.7-.7 1.4-1.2 2-1 1.3-1.9 2.7-3.1 4-2.2 2.7-5 5-8.1 7.1L70 85.7c-.8.5-1.7.9-2.6 1.3l-1.4.7-1.4.5c-.9.3-1.8.7-2.8 1C58 90.3 53.9 90.9 50 91l-3-.2c-1 0-2-.2-3-.3l-1.5-.2-.7-.1-.7-.2c-1-.3-1.9-.5-2.9-.7-.9-.3-1.9-.7-2.8-1l-1.4-.6-1.3-.6c-.9-.4-1.8-.8-2.6-1.3l-2.4-1.5c-3.1-2.1-5.9-4.5-8.1-7.1-1.2-1.2-2.1-2.7-3.1-4-.5-.6-.8-1.4-1.2-2-.4-.7-.8-1.3-1.1-2-.3-.7-.6-1.3-.9-2-.3-.7-.6-1.3-.8-1.9-.4-1.3-.9-2.5-1.2-3.7-.3-1.2-.5-2.3-.7-3.3-.2-1-.3-2-.4-2.8-.1-.4-.1-.8-.1-1.2v-1.1-1.7c-.1-1-.1-1.5-.1-1.5z",
  fill: "#337ab7",
  filter: "url(#a)"
}, React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 50 50",
  to: "360 50 50",
  repeatCount: "indefinite",
  dur: "1s"
}));

var LoadingIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20width%3D%5Ci120px%5Ci%20height%3D%5Ci120px%5Ci%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20100%20100%22%20preserveAspectRatio%3D%22xMidYMid%22%20class%3D%22uil-ring%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%22100%22%20height%3D%22100%22%20fill%3D%22none%22%20class%3D%22bk%22%3E%3C%2Frect%3E%3Cdefs%3E%3Cfilter%20id%3D%22uil-ring-shadow%22%20x%3D%22-100%25%22%20y%3D%22-100%25%22%20width%3D%22300%25%22%20height%3D%22300%25%22%3E%3CfeOffset%20result%3D%22offOut%22%20in%3D%22SourceGraphic%22%20dx%3D%220%22%20dy%3D%220%22%3E%3C%2FfeOffset%3E%3CfeGaussianBlur%20result%3D%22blurOut%22%20in%3D%22offOut%22%20stdDeviation%3D%220%22%3E%3C%2FfeGaussianBlur%3E%3CfeBlend%20in%3D%22SourceGraphic%22%20in2%3D%22blurOut%22%20mode%3D%22normal%22%3E%3C%2FfeBlend%3E%3C%2Ffilter%3E%3C%2Fdefs%3E%3Cpath%20d%3D%22M10%2C50c0%2C0%2C0%2C0.5%2C0.1%2C1.4c0%2C0.5%2C0.1%2C1%2C0.2%2C1.7c0%2C0.3%2C0.1%2C0.7%2C0.1%2C1.1c0.1%2C0.4%2C0.1%2C0.8%2C0.2%2C1.2c0.2%2C0.8%2C0.3%2C1.8%2C0.5%2C2.8%20c0.3%2C1%2C0.6%2C2.1%2C0.9%2C3.2c0.3%2C1.1%2C0.9%2C2.3%2C1.4%2C3.5c0.5%2C1.2%2C1.2%2C2.4%2C1.8%2C3.7c0.3%2C0.6%2C0.8%2C1.2%2C1.2%2C1.9c0.4%2C0.6%2C0.8%2C1.3%2C1.3%2C1.9%20c1%2C1.2%2C1.9%2C2.6%2C3.1%2C3.7c2.2%2C2.5%2C5%2C4.7%2C7.9%2C6.7c3%2C2%2C6.5%2C3.4%2C10.1%2C4.6c3.6%2C1.1%2C7.5%2C1.5%2C11.2%2C1.6c4-0.1%2C7.7-0.6%2C11.3-1.6%20c3.6-1.2%2C7-2.6%2C10-4.6c3-2%2C5.8-4.2%2C7.9-6.7c1.2-1.2%2C2.1-2.5%2C3.1-3.7c0.5-0.6%2C0.9-1.3%2C1.3-1.9c0.4-0.6%2C0.8-1.3%2C1.2-1.9%20c0.6-1.3%2C1.3-2.5%2C1.8-3.7c0.5-1.2%2C1-2.4%2C1.4-3.5c0.3-1.1%2C0.6-2.2%2C0.9-3.2c0.2-1%2C0.4-1.9%2C0.5-2.8c0.1-0.4%2C0.1-0.8%2C0.2-1.2%20c0-0.4%2C0.1-0.7%2C0.1-1.1c0.1-0.7%2C0.1-1.2%2C0.2-1.7C90%2C50.5%2C90%2C50%2C90%2C50s0%2C0.5%2C0%2C1.4c0%2C0.5%2C0%2C1%2C0%2C1.7c0%2C0.3%2C0%2C0.7%2C0%2C1.1%20c0%2C0.4-0.1%2C0.8-0.1%2C1.2c-0.1%2C0.9-0.2%2C1.8-0.4%2C2.8c-0.2%2C1-0.5%2C2.1-0.7%2C3.3c-0.3%2C1.2-0.8%2C2.4-1.2%2C3.7c-0.2%2C0.7-0.5%2C1.3-0.8%2C1.9%20c-0.3%2C0.7-0.6%2C1.3-0.9%2C2c-0.3%2C0.7-0.7%2C1.3-1.1%2C2c-0.4%2C0.7-0.7%2C1.4-1.2%2C2c-1%2C1.3-1.9%2C2.7-3.1%2C4c-2.2%2C2.7-5%2C5-8.1%2C7.1%20c-0.8%2C0.5-1.6%2C1-2.4%2C1.5c-0.8%2C0.5-1.7%2C0.9-2.6%2C1.3L66%2C87.7l-1.4%2C0.5c-0.9%2C0.3-1.8%2C0.7-2.8%2C1c-3.8%2C1.1-7.9%2C1.7-11.8%2C1.8L47%2C90.8%20c-1%2C0-2-0.2-3-0.3l-1.5-0.2l-0.7-0.1L41.1%2C90c-1-0.3-1.9-0.5-2.9-0.7c-0.9-0.3-1.9-0.7-2.8-1L34%2C87.7l-1.3-0.6%20c-0.9-0.4-1.8-0.8-2.6-1.3c-0.8-0.5-1.6-1-2.4-1.5c-3.1-2.1-5.9-4.5-8.1-7.1c-1.2-1.2-2.1-2.7-3.1-4c-0.5-0.6-0.8-1.4-1.2-2%20c-0.4-0.7-0.8-1.3-1.1-2c-0.3-0.7-0.6-1.3-0.9-2c-0.3-0.7-0.6-1.3-0.8-1.9c-0.4-1.3-0.9-2.5-1.2-3.7c-0.3-1.2-0.5-2.3-0.7-3.3%20c-0.2-1-0.3-2-0.4-2.8c-0.1-0.4-0.1-0.8-0.1-1.2c0-0.4%2C0-0.7%2C0-1.1c0-0.7%2C0-1.2%2C0-1.7C10%2C50.5%2C10%2C50%2C10%2C50z%22%20fill%3D%22%23337ab7%22%20filter%3D%22url%28%23uil-ring-shadow%29%22%3E%3CanimateTransform%20attributeName%3D%22transform%22%20type%3D%22rotate%22%20from%3D%220%2050%2050%22%20to%3D%22360%2050%2050%22%20repeatCount%3D%22indefinite%22%20dur%3D%221s%22%3E%3C%2FanimateTransform%3E%3C%2Fpath%3E%3C%2Fsvg%3E";
var CSVLink = reactCsv.CSVLink;
var useStyles$b = makeStyles(function (theme) {
  return {
    root: {
      width: "100%",
      paddingBottom: theme.spacing(2)
    },
    table: {
      minWidth: 750
    },
    tableWrapper: {
      overflowX: "auto",
      maxHeight: 800
    },
    tableHeader: {
      color: theme.palette.primary.dark,
      "&:hover": {
        color: theme.palette.primary.main
      }
    },
    stickyHeader: {
      backgroundColor: "#ffffff"
    },
    controlsBar: {
      display: "flex",
      alignItems: "center",
      marginBottom: theme.spacing(1),
      "&:hover": {
        cursor: "pointer"
      },
      "& div": {
        marginRight: theme.spacing(2)
      }
    },
    divider: {
      margin: theme.spacing(2, 0)
    },
    imgWrapper: {
      width: 300,
      margin: theme.spacing(10) + "px auto " + theme.spacing(4) + "px auto"
    },
    img: {
      maxWidth: "100%"
    },
    loadingWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 300
    },
    dialog: {
      padding: theme.spacing(2)
    },
    dialogActions: {
      justifyContent: "flex-start",
      marginBottom: theme.spacing(2),
      marginLeft: theme.spacing(2)
    },
    dialogWrapper: {
      padding: theme.spacing(0, 3)
    },
    margin: {
      margin: theme.spacing(2)
    },
    marginTop: {
      marginTop: theme.spacing(2)
    },
    marginBottom: {
      marginBottom: theme.spacing(2)
    },
    fileName: {
      marginBottom: theme.spacing(1),
      width: 500
    },
    downloadBtn: {
      boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
      backgroundColor: theme.palette.secondary.main,
      color: "#ffffff",
      textDecoration: "none",
      padding: "6px 16px",
      fontSize: "0.875rem",
      minWidth: 64,
      boxSizing: "border-box",
      transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      fontWeight: 500,
      lineHeight: 1.75,
      borderRadius: 4,
      letterSpacing: "0.02857em",
      textTransform: "uppercase",
      marginTop: theme.spacing(2),
      "&:hover": {
        boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
        backgroundColor: "#388e3c"
      }
    }
  };
});

var Table$2 = function Table$$1(_ref) {
  var data = _ref.data,
      columns = _ref.columns,
      title = _ref.title,
      height = _ref.height,
      loading = _ref.loading,
      props = objectWithoutProperties(_ref, ["data", "columns", "title", "height", "loading"]);
  var classes = useStyles$b();

  var _useTable = useTable(data, columns),
      headers = _useTable.headers,
      keys = _useTable.keys,
      excludeNulls = _useTable.excludeNulls,
      filters = _useTable.filters,
      columnToggles = _useTable.columnToggles,
      filteredKeys = _useTable.filteredKeys,
      tableData = _useTable.tableData,
      order = _useTable.order,
      orderBy = _useTable.orderBy,
      handleSort = _useTable.handleSort,
      handleFilteredKeys = _useTable.handleFilteredKeys,
      handleFilteredValues = _useTable.handleFilteredValues,
      handleExcludeNulls = _useTable.handleExcludeNulls;

  var _useVisibility = useVisibility(false),
      _useVisibility2 = slicedToArray(_useVisibility, 2),
      filtersVisibility = _useVisibility2[0],
      handleFiltersVisibility = _useVisibility2[1];

  var _useVisibility3 = useVisibility(false),
      _useVisibility4 = slicedToArray(_useVisibility3, 2),
      columnTogglesVisibility = _useVisibility4[0],
      handleColumnTogglesVisibility = _useVisibility4[1];

  var _useVisibility5 = useVisibility(false),
      _useVisibility6 = slicedToArray(_useVisibility5, 2),
      dataDownloadVisibility = _useVisibility6[0],
      handleDataDownloadVisibility = _useVisibility6[1];

  var _useState = useState(""),
      _useState2 = slicedToArray(_useState, 2),
      fileName = _useState2[0],
      setFileName = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = slicedToArray(_useState3, 2),
      activePage = _useState4[0],
      setActivePage = _useState4[1];

  var rowsPerPage = 60;
  /**
   * Event handler for table pagination
   * @param {*} event
   * @param {*} newPage
   */

  var handleChangePage = function handleChangePage(event, newPage) {
    setActivePage(newPage);
  };
  /**
   * Utility function used to set height and overflow
   * styles for the table
   */


  var setStyles = function setStyles() {
    if (height) {
      return {
        height: height,
        overflow: "auto"
      };
    }

    return {};
  };

  if (loading) {
    return React.createElement("div", {
      className: classes.loadingWrapper
    }, React.createElement("img", {
      src: LoadingIcon,
      alt: "loading"
    }));
  }

  return React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    style: setStyles()
  }, title && React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary",
    gutterBottom: true
  }, title), data.length === 0 && React.createElement("div", null, React.createElement("div", {
    className: classes.imgWrapper
  }, React.createElement("img", {
    src: NoDataIllustration,
    alt: "No Data",
    className: classes.img
  })), React.createElement(Typography, {
    variant: "body1",
    align: "center"
  }, "No data found for the currently selected filters.")), data.length > 0 && React.createElement(React.Fragment, null, React.createElement("div", {
    className: classes.controlsBar
  }, filters.filter(function (col) {
    return col.filter.enabled;
  }).length > 0 && React.createElement("div", {
    onClick: handleFiltersVisibility
  }, React.createElement(Tooltip, {
    title: "Filter Records"
  }, React.createElement(IconButton, {
    "aria-label": "Filter Records"
  }, React.createElement(FilterListIcon, {
    color: filtersVisibility ? "primary" : "inherit"
  }))), React.createElement(Typography, {
    variant: "button",
    display: "inline",
    color: filtersVisibility ? "primary" : "initial"
  }, "Filter Records")), columnToggles.filter(function (col) {
    return col.columnToggle.enabled;
  }).length > 0 && React.createElement("div", {
    onClick: handleColumnTogglesVisibility
  }, React.createElement(Tooltip, {
    title: "Toggle Columns"
  }, React.createElement(IconButton, {
    "aria-label": "Toggle Columns"
  }, React.createElement(ColumnsIcon, {
    color: columnTogglesVisibility ? "primary" : "inherit"
  }))), React.createElement(Typography, {
    variant: "button",
    display: "inline",
    color: columnTogglesVisibility ? "primary" : "initial"
  }, "Toggle Columns")), React.createElement(Switch$1, {
    name: "exclude_nulls",
    label: "Exclude Nulls",
    value: "exclude_nulls",
    checked: excludeNulls,
    onChange: handleExcludeNulls,
    color: "primary"
  }), React.createElement("div", {
    onClick: handleDataDownloadVisibility
  }, React.createElement(Tooltip, {
    title: "Download Data"
  }, React.createElement(IconButton, {
    "aria-label": "Download Data"
  }, React.createElement(DownloadIcon, null))), React.createElement(Typography, {
    variant: "button",
    display: "inline",
    className: classes.controlText
  }, "Download Data"))), React.createElement(Filters, {
    filters: filters,
    visible: filtersVisibility,
    visibilityHandler: handleFiltersVisibility,
    handleFilter: handleFilteredValues
  }), React.createElement(ColumnToggles, {
    columns: columns,
    selections: filteredKeys,
    visible: columnTogglesVisibility,
    visibilityHandler: handleColumnTogglesVisibility,
    handleToggle: handleFilteredKeys
  }), React.createElement(Divider, {
    className: classes.divider
  }), React.createElement(Table, _extends({
    "aria-label": "Table"
  }, props), React.createElement(TableHead, null, React.createElement(TableRow, null, headers.map(function (header, index) {
    return React.createElement(TableCell, {
      key: header,
      sortDirection: orderBy === keys[index] ? order : false,
      classes: {
        root: classes.tableHeader,
        stickyHeader: classes.stickyHeader
      }
    }, React.createElement(TableSortLabel, {
      active: orderBy === keys[index],
      direction: order,
      onClick: function onClick() {
        return handleSort(keys[index]);
      }
    }, header));
  }))), React.createElement(TableBody, null, tableData.slice(activePage * rowsPerPage, activePage * rowsPerPage + rowsPerPage).map(function (row) {
    return React.createElement(TableRow, {
      key: Math.random() * 9999999
    }, keys.map(function (key) {
      return React.createElement(TableCell, {
        key: Math.random() * 9999999
      }, row[key]);
    }));
  }))))), tableData.length > rowsPerPage && React.createElement(TablePagination, {
    rowsPerPageOptions: [31],
    component: "div",
    count: tableData.length,
    rowsPerPage: rowsPerPage,
    page: activePage,
    onChangePage: handleChangePage
  }), React.createElement(Dialog, {
    onClose: handleDataDownloadVisibility,
    "aria-labelledby": "simple-dialog-title",
    open: dataDownloadVisibility,
    fullWidth: true,
    maxWidth: "sm",
    className: classes.dialog
  }, React.createElement(DialogTitle, null, "Data Download"), React.createElement("div", {
    className: classes.dialogWrapper
  }, React.createElement(Typography, {
    variant: "body1",
    paragraph: true
  }, "INSTRUCTIONS HERE"), React.createElement("form", null, React.createElement(TextField, {
    id: "file_name",
    className: classes.fileName,
    name: "file_name",
    label: "File Name",
    variant: "outlined",
    onChange: function onChange(e) {
      return setFileName(e.target.value);
    },
    value: fileName,
    required: true
  }))), React.createElement(DialogActions, {
    classes: {
      root: classes.dialogActions
    }
  }, React.createElement(CSVLink, {
    data: tableData,
    className: classes.downloadBtn,
    filename: fileName + ".csv",
    target: "_blank",
    onClick: handleDataDownloadVisibility
  }, "Download"), React.createElement(Button, {
    onClick: handleDataDownloadVisibility,
    variant: "contained",
    className: classes.marginTop
  }, "Cancel"))));
};

Table$2.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired
};
var useStyles$c = makeStyles$1(function (theme) {
  return {
    tableHeader: {
      color: theme.palette.primary.dark,
      "&:hover": {
        color: theme.palette.primary.main
      }
    },
    stickyHeader: {
      backgroundColor: "#ffffff"
    }
  };
});

var EditableTableHead = function EditableTableHead(props) {
  var onSelectAllClick = props.onSelectAllClick,
      order = props.order,
      orderBy = props.orderBy,
      numSelected = props.numSelected,
      rowCount = props.rowCount,
      onRequestSort = props.onRequestSort,
      columns = props.columns,
      selectionsEnabled = props.selectionsEnabled;
  var classes = useStyles$c();

  var createSortHandler = function createSortHandler(property) {
    return function (event) {
      onRequestSort(property);
    };
  };

  return React.createElement(TableHead$1, null, React.createElement(TableRow$1, null, selectionsEnabled && React.createElement(TableCell$1, {
    padding: "checkbox",
    classes: {
      stickyHeader: classes.stickyHeader
    }
  }, React.createElement(Checkbox$1, {
    color: "primary",
    indeterminate: numSelected > 0 && numSelected < rowCount,
    checked: numSelected === rowCount,
    onChange: onSelectAllClick,
    inputProps: {
      "aria-label": "Select all desserts"
    }
  })), columns.map(function (row) {
    return React.createElement(TableCell$1, {
      key: Math.random() * 9999999,
      align: row.numeric ? "center" : "left",
      sortDirection: orderBy === row.id ? order : false,
      classes: {
        root: classes.tableHeader,
        stickyHeader: classes.stickyHeader
      }
    }, React.createElement(TableSortLabel$1, {
      active: orderBy === row.id,
      direction: order,
      onClick: createSortHandler(row.id)
    }, row.label));
  })));
};

EditableTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

function toVal(mix) {
  var k,
      y,
      str = '';

  if (mix) {
    if (typeof mix === 'object') {
      if (Array.isArray(mix)) {
        for (k = 0; k < mix.length; k++) {
          if (mix[k] && (y = toVal(mix[k]))) {
            str && (str += ' ');
            str += y;
          }
        }
      } else {
        for (k in mix) {
          if (mix[k] && (y = toVal(k))) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else if (typeof mix !== 'boolean' && !mix.call) {
      str && (str += ' ');
      str += mix;
    }
  }

  return str;
}

function clsx() {
  var i = 0,
      x,
      str = '';

  while (i < arguments.length) {
    if (x = toVal(arguments[i++])) {
      str && (str += ' ');
      str += x;
    }
  }

  return str;
}

function AlertDialog(props) {
  var handleDelete = props.handleDelete;

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function dialogHandler(consent) {
    if (consent === "agree") {
      handleDelete();
    }

    handleClose();
  }

  return React.createElement("div", null, React.createElement(Tooltip$1, {
    title: "Delete",
    onClick: handleClickOpen
  }, React.createElement(IconButton$1, {
    "aria-label": "Delete"
  }, React.createElement(DeleteIcon, null))), React.createElement(Dialog$1, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, React.createElement(DialogTitle$1, {
    id: "alert-dialog-title"
  }, "Record Delete"), React.createElement(DialogContent, null, React.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, "Are you sure you want to delete this record(s)? Doing so cannot be undone")), React.createElement(DialogActions$1, null, React.createElement(Button$1, {
    onClick: function onClick() {
      return dialogHandler("disagree");
    },
    color: "primary"
  }, "Cancel"), React.createElement(Button$1, {
    onClick: function onClick() {
      return dialogHandler("agree");
    },
    color: "secondary",
    autoFocus: true
  }, "Agree"))));
}

var ITEM_HEIGHT$1 = 48;
var ITEM_PADDING_TOP$1 = 8;
var MenuProps$1 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT$1 * 4.5 + ITEM_PADDING_TOP$1,
      width: 250
    }
  }
};
var useFilterStyles = makeStyles(function (theme) {
  return {
    filters: {
      padding: 15,
      marginBottom: 30,
      backgroundColor: "#f9f9f9"
    },
    formControl: {
      marginTop: 15,
      marginRight: 15,
      minWidth: 120,
      maxWidth: 200
    }
  };
});

var EditableTableFilters = function EditableTableFilters(props) {
  var classes = useFilterStyles();
  var data = props.data,
      columns = props.columns,
      handleFilterChange = props.handleFilterChange;

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      filtersData = _useState2[0],
      setFiltersData = _useState2[1];

  var getFilterValues = function getFilterValues(data, column) {
    return [].concat(toConsumableArray(new Set(data.map(function (d) {
      return d[column];
    }))));
  };

  var handleChange = function handleChange(e, id) {
    var value = e.target.value;
    setFiltersData(function (prevState) {
      return prevState.map(function (d) {
        if (d.id === id) {
          return Object.assign(d, {
            active: value
          });
        }

        return d;
      });
    });
    handleFilterChange(filtersData);
  };

  useEffect(function () {
    var filters = columns.filter(function (col) {
      return col.filterEnabled !== false;
    }).map(function (col) {
      return {
        id: col.id,
        label: col.label,
        values: getFilterValues(data, col.id),
        active: getFilterValues(data, col.id)
      };
    });
    setFiltersData(filters);
  }, [data, columns]);
  if (filtersData.length === 0) return null;
  return React.createElement("div", {
    className: classes.filters
  }, React.createElement(Typography$1, {
    variant: "h6"
  }, "Filters"), filtersData.map(function (filter) {
    return React.createElement(FormControl$1, {
      key: Math.random() * 9999999,
      id: filter.id,
      className: classes.formControl
    }, React.createElement(InputLabel$1, {
      htmlFor: filter.id
    }, filter.label), React.createElement(Select$1, {
      multiple: true,
      value: filter.active,
      onChange: function onChange(e) {
        return handleChange(e, filter.id);
      },
      input: React.createElement(Input, {
        id: "filter",
        classes: {
          underline: classes.input
        }
      }),
      renderValue: function renderValue(selected) {
        return selected.join(", ");
      },
      MenuProps: MenuProps$1,
      classes: {
        root: classes.multiSelect,
        select: classes.select,
        icon: classes.inputIcon
      },
      className: classes.multiSelect
    }, filter.values.map(function (val) {
      return React.createElement(MenuItem$1, {
        key: val || Math.random() * 9999999,
        value: val
      }, React.createElement(Checkbox$1, {
        checked: filter.active.includes(val)
      }), React.createElement(ListItemText$1, {
        primary: val
      }));
    })));
  }));
};

EditableTableFilters.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  handleFilterChange: PropTypes.func
};
var useToolbarStyles = makeStyles(function (theme) {
  return {
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1)
    },
    highlight: theme.palette.type === "light" ? {
      color: theme.palette.primary.main,
      backgroundColor: lighten(theme.palette.primary.light, 0.85)
    } : {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.primary.dark
    },
    spacer: {
      flex: "1 1 100%"
    },
    actions: {
      color: theme.palette.text.primary
    },
    title: {
      flex: "0 0 auto"
    },
    filters: {
      padding: 15,
      marginBottom: 30,
      backgroundColor: "#f9f9f9"
    },
    formControl: {
      marginTop: 15,
      marginRight: 15,
      minWidth: 120,
      maxWidth: 200
    }
  };
});

var FilterButtons = function FilterButtons(_ref) {
  var filters = _ref.filters,
      filtersHandler = _ref.filtersHandler;
  return React.createElement(Tooltip$1, {
    title: "Filter Records"
  }, React.createElement(IconButton$1, {
    "aria-label": "Filter list",
    onClick: filtersHandler
  }, React.createElement(FilterListIcon, null)));
};

var EditableTableToolbar = function EditableTableToolbar(props) {
  var classes = useToolbarStyles();
  var numSelected = props.numSelected,
      title = props.title,
      data = props.data,
      columns = props.columns,
      selected = props.selected,
      handleDelete = props.handleDelete,
      handleFilterChange = props.handleFilterChange,
      handleClearSelected = props.handleClearSelected;

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      filtersVisible = _useState2[0],
      setFiltersVisible = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = slicedToArray(_useState3, 2),
      filtersEnabled = _useState4[0],
      setFiltersEnabled = _useState4[1];

  var displayFilters = function displayFilters() {
    setFiltersVisible(function (prev) {
      return !prev;
    });
  };

  var handleDeleted = function handleDeleted(selected) {
    handleDelete(selected);
    handleClearSelected();
  };

  useEffect(function () {
    var enabledFilters = columns.filter(function (d) {
      return d.filterEnabled !== false;
    });

    if (enabledFilters.length === 0) {
      setFiltersEnabled(false);
    } else {
      setFiltersEnabled(true);
    }
  }, [columns]);
  return React.createElement("div", null, React.createElement(Toolbar, {
    className: clsx(classes.root, defineProperty({}, classes.highlight, numSelected > 0))
  }, React.createElement("div", {
    className: classes.title
  }, numSelected > 0 ? React.createElement(Typography$1, {
    color: "inherit",
    variant: "subtitle1"
  }, numSelected, " selected") : React.createElement(Typography$1, {
    variant: "h6",
    id: "tableTitle"
  }, title)), React.createElement("div", {
    className: classes.spacer
  }), React.createElement("div", {
    className: classes.actions
  }, numSelected > 0 ? React.createElement(AlertDialog, {
    handleDelete: function handleDelete() {
      return handleDeleted(selected);
    }
  }) : React.createElement(FilterButtons, {
    filters: filtersEnabled,
    filtersHandler: displayFilters
  }))), React.createElement(Collapse$1, {
    "in": filtersVisible
  }, React.createElement(EditableTableFilters, {
    data: data,
    columns: columns,
    handleFilterChange: handleFilterChange
  })));
};

EditableTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired
};
var useStyles$d = makeStyles(function (theme) {
  return {
    root: {
      width: "100%"
    },
    table: {
      minWidth: 750
    },
    tableWrapper: {
      overflowX: "auto",
      maxHeight: 700
    }
  };
});

var EditableTable = function EditableTable(props) {
  var data = props.data,
      columns = props.columns,
      title = props.title,
      _props$size = props.size,
      size = _props$size === undefined ? "medium" : _props$size,
      _props$handleRowClick = props.handleRowClick,
      handleRowClick = _props$handleRowClick === undefined ? function () {} : _props$handleRowClick,
      _props$handleDelete = props.handleDelete,
      handleDelete = _props$handleDelete === undefined ? function () {} : _props$handleDelete,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === undefined ? false : _props$stickyHeader,
      _props$selectionsEnab = props.selectionsEnabled,
      selectionsEnabled = _props$selectionsEnab === undefined ? true : _props$selectionsEnab;
  var classes = useStyles$d();

  var _useState = useState("asc"),
      _useState2 = slicedToArray(_useState, 2),
      order = _useState2[0],
      setOrder = _useState2[1];

  var _useState3 = useState("calories"),
      _useState4 = slicedToArray(_useState3, 2),
      orderBy = _useState4[0],
      setOrderBy = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = slicedToArray(_useState7, 2),
      originalData = _useState8[0],
      setOriginalData = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = slicedToArray(_useState9, 2),
      tableData = _useState10[0],
      setTableData = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = slicedToArray(_useState11, 2),
      chipColorAssignments = _useState12[0],
      setChipColorAssignments = _useState12[1];

  var _useState13 = useState(0),
      _useState14 = slicedToArray(_useState13, 2),
      activePage = _useState14[0],
      setActivePage = _useState14[1];

  var rowsPerPage = 60;
  /**
   * Event handler for table pagination
   * @param {*} event
   * @param {*} newPage
   */

  var handleChangePage = function handleChangePage(event, newPage) {
    setActivePage(newPage);
  };

  var handleRequestSort = function handleRequestSort(property) {
    var isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };

  var handleSelectAllClick = function handleSelectAllClick(event) {
    var keys = Object.keys(tableData[0]);

    if (event.target.checked) {
      var newSelecteds = tableData.map(function (n) {
        return n[keys[0]];
      });
      setSelected(newSelecteds);
      return;
    }

    setSelected([]);
  };

  var handleClearSelected = function handleClearSelected() {
    setSelected([]);
  };

  var handleClick = function handleClick(event, row) {
    var targetType = event.target.type;

    if (targetType === "checkbox") {
      handleCheckboxClick(event, row);
      handleRowClick(row);
    } else {
      handleRowClick(row);
    }
  };

  var handleCheckboxClick = function handleCheckboxClick(event, row) {
    var keys = Object.keys(row);
    var field1 = row[keys[0]];
    var selectedIndex = selected.indexOf(field1);
    var newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, field1);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  var handleFilterChange = function handleFilterChange(filters) {
    var filteredData = originalData;
    filters.forEach(function (filter) {
      filteredData = filteredData.filter(function (d) {
        return filter.active.includes(d[filter.id]);
      });
    });
    setTableData(filteredData);
  };

  var isSelected = function isSelected(row) {
    var keys = Object.keys(row);
    var field1 = row[keys[0]];

    if (selected.indexOf(field1) !== -1) {
      return true;
    }

    return false;
  }; // handle chip color assignments


  useEffect(function () {
    var chipColors = ["#4074DC", "#47ab67", "#39a5db", "#ca3b76", "#109c9e", "#380a6e", "#9e6502"];

    var assignChipColors = function assignChipColors() {
      var chipColumns = columns.filter(function (col) {
        return col.chip;
      });
      var assignments = chipColumns.map(function (col) {
        var cats = [].concat(toConsumableArray(new Set(data.map(function (d) {
          return d[col.id];
        }))));
        var assignments = {};
        cats.forEach(function (cat, index) {
          assignments[cat] = chipColors[index];
        });
        return {
          id: col.id,
          assignments: assignments
        };
      })[0];
      setChipColorAssignments(assignments);
    };

    assignChipColors(columns);
  }, [columns, data]);
  useEffect(function () {
    setOriginalData(data);
    setTableData(data);
  }, [data]);
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(EditableTableToolbar, {
    numSelected: selected.length,
    title: title,
    data: originalData,
    columns: columns,
    selected: selected,
    handleFilterChange: handleFilterChange,
    handleDelete: handleDelete,
    handleClearSelected: handleClearSelected
  }), React.createElement("div", {
    className: classes.tableWrapper
  }, React.createElement(Table$1, {
    className: classes.table,
    "aria-labelledby": "tableTitle",
    size: size,
    stickyHeader: stickyHeader
  }, React.createElement(EditableTableHead, {
    numSelected: selected.length,
    order: order,
    orderBy: orderBy,
    onSelectAllClick: handleSelectAllClick,
    onRequestSort: handleRequestSort,
    rowCount: tableData.length,
    columns: columns,
    selectionsEnabled: selectionsEnabled
  }), React.createElement(TableBody$1, null, stableSort(tableData, getSorting(order, orderBy)).map(function (row, index) {
    var isItemSelected = isSelected(row);
    var labelId = "enhanced-table-checkbox-" + index;
    return React.createElement(TableRow$1, {
      hover: true,
      onClick: function onClick(event) {
        return handleClick(event, row);
      },
      role: selectionsEnabled ? "checkbox" : "default",
      "aria-checked": isItemSelected,
      tabIndex: -1,
      key: Math.random() * 99999999,
      selected: isItemSelected
    }, selectionsEnabled && React.createElement(React.Fragment, null, React.createElement(TableCell$1, {
      padding: "checkbox"
    }, React.createElement(Checkbox$1, {
      color: "primary",
      checked: isItemSelected,
      inputProps: {
        "aria-labelledby": labelId
      }
    }))), React.createElement(TableCell$1, {
      component: "th",
      id: labelId,
      scope: "row"
    }, row[columns[0].id]), columns.map(function (col, index) {
      if (index !== 0 && !col.chip) {
        return React.createElement(TableCell$1, {
          key: Math.floor(Math.random() * 9999999),
          align: col.numeric ? "center" : "left"
        }, typeof row[col.id] === "boolean" ? row[col.id].toString() : row[col.id]);
      } else if (index !== 0 && col.chip) {
        var chipColor = chipColorAssignments !== null ? chipColorAssignments.assignments[row[col.id]] : "#dddddd";
        return React.createElement(TableCell$1, {
          key: Math.floor(Math.random() * 9999999),
          align: col.numeric ? "center" : "left"
        }, React.createElement(Chip, {
          label: row[col.id],
          style: {
            backgroundColor: chipColor,
            color: "#ffffff"
          }
        }));
      }

      return null;
    }));
  }))), React.createElement(TablePagination$1, {
    rowsPerPageOptions: [30],
    component: "div",
    count: tableData.length,
    rowsPerPage: rowsPerPage,
    page: activePage,
    onChangePage: handleChangePage
  })));
};

EditableTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  title: PropTypes.string,
  handleRowClick: PropTypes.func,
  handleDelete: PropTypes.func
};
export { DatePicker, Switch$1 as Switch, TextField$1 as TextField, TextArea, SingleSelectFilter as Select, MultiSelect, FilterAdvanced, Submit as FilterActions, FilterBar, Table$2 as Table, EditableTable };